import { useTranslation } from '@wix/fe-essentials/react';
import { useA11yWizardAdapter } from '../../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { showFailedFetchRuleExecutionResultsModal } from '../../../../modals/show-failed-fetch-rule-execution-results';
export const useShowFetchErrorModal = () => {
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const showFetchErrorModal = _ref => {
    let {
      tryAgainCallback,
      cancelCallback
    } = _ref;
    return showFailedFetchRuleExecutionResultsModal({
      a11yWizardAdapter,
      biLogger,
      editorHost,
      errorMessage: t('accessibility-wizard.fetch-rule-execution-results.failed-to-fetch-results-modal.content'),
      handleCancel: cancelCallback,
      handleTryAgain: tryAgainCallback,
      t,
      title: t('accessibility-wizard.fetch-rule-execution-results.failed-to-fetch-results-modal.title')
    });
  };
  return showFetchErrorModal;
};
//# sourceMappingURL=use-show-fetch-error-modal.js.map